import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
  isDevMode, importProvidersFrom
} from '@angular/core';
import {provideRouter, RouteReuseStrategy} from '@angular/router';

import { routes } from './app.routes';
import {IonicRouteStrategy, provideIonicAngular} from '@ionic/angular/standalone';
import {HttpClient, provideHttpClient, withFetch} from '@angular/common/http';
import {LanguageService} from './core/language.service';
import { provideServiceWorker } from '@angular/service-worker';
import { ClipboardModule } from '@angular/cdk/clipboard';
import {customPageTransition} from './animations/custom-transition';
import {GtmService} from './init/gtm.service';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, provideAuth } from '@angular/fire/auth';
// Analytics moved to lazy loading for better performance
// import { getAnalytics, provideAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';
import {NgcCookieConsentConfig, provideNgcCookieConsent} from 'ngx-cookieconsent';
import {environment} from '../environments/environment';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {provideClientHydration, withIncrementalHydration} from '@angular/platform-browser';
import { provideServiceWorkerUpdates } from './core/sw-update.service';

export function initializeLanguageFactory(init: LanguageService) {
  return init.initializeApp();
}
export function initializeGtmFactory(init: GtmService) {
  return init.initializeGtm();
}
const cookieConfig:NgcCookieConsentConfig = {
  cookie: {
    domain: environment.production ? 'satel.sa' : 'localhost'
  },
  palette: {
    popup: {
      background: '#000'
    },
    button: {
      background: '#f1d600'
    }
  },
  theme: 'edgeless',
  type: 'opt-out'
};

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgcCookieConsent(cookieConfig),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withFetch()),
    provideClientHydration(withIncrementalHydration()),
    provideIonicAngular({
      mode: 'ios',
      navAnimation: customPageTransition
    }),
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideAppInitializer(() => initializeLanguageFactory(inject(LanguageService))),
    provideServiceWorker('ngsw-worker.js', {
            enabled: !isDevMode(),
            registrationStrategy: 'registerWhenStable:5000'
          }),
    ...provideServiceWorkerUpdates(),
    ClipboardModule,
    provideAppInitializer(() => initializeGtmFactory(inject(GtmService))),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(
      [TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient]
        }
      })]
    ),
    provideAuth(() => getAuth()),
    // Analytics providers removed - loaded lazily via lazy-loading.service.ts
    // provideLottieOptions({
    //   player: () => import('lottie-web'),
    // })
  ],
};
